import { Button, NonIdealState } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';

const PersonCardNoResult = ({ className, onReset, title, description }) => (
  <NonIdealState
    action={<Button onClick={() => onReset()}>Reset search</Button>}
    className={className}
    description={description || "Your search didn't match any files. Try searching for something else."}
    icon="search"
    title={title || "No search results"}
  />
);

PersonCardNoResult.defaultProps = {
  className: undefined,
  title: undefined,
  description: undefined,
};

PersonCardNoResult.propTypes = {
  className: PropTypes.string,
  onReset: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default PersonCardNoResult;
